export default "__VITE_ASSET__C8pqu$$b__"